import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyAccessManagement = {
  getStudyAccessManagementGroups,
  getStudyUserPermission,
  assignUnassignGroupsofStudyManagement,
  getAssignedGroupToUser,
  updateStudyManagementGroupName,
  deleteStudyManagementGroupName,
  createStudyAccessManagement,
};

async function getStudyAccessManagementGroups(studyId, category) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyAccessManagementGroups/${studyId}/${category}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyUserPermission(studyId, category) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserPermission/${studyId}/${category}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAssignedGroupToUser(studyId, permissionId, category) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAssignedGroupToUser/${studyId}/${permissionId}/${category}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function assignUnassignGroupsofStudyManagement(accessData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignUnassignGroupsofStudyManagement`,
    headersWithAuth("PUT", accessData, headers)
  );
  const data = await response.json();
  await handleResponse(data);
  return data
}

async function updateStudyManagementGroupName(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyManagementGroupName`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  await handleResponse(data);
  return data
}

async function deleteStudyManagementGroupName(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyManagementGroupName`,
    headersWithAuth("DELETE", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function createStudyAccessManagement(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createStudyAccessManagement`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  await handleResponse(data);
  return data
}